<template>
	<div class="about-container">
		<div class="container">
		<!-- <footer-s></footer-s> -->
			<loginHeader></loginHeader>

		<div class="about">
			<img src="../../assets/img/about-d.jpg" class="about-sign"/>
			<div class="bn-box">
				
				<div :class="isFixed?'bn-left-bg bn-left-bg-fixed':'bn-left-bg'" >
					<div class="bn-left">
						<ul class="bn-left-list">
							<li class="bn-left-padding">
								<i class="bn-left-ic"></i>
							</li>
							<li>
								<div :class="titleItemActive==0?'menu-item active':'menu-item'" @click="scrollTo(0)">
									<i class="bn-left-i"></i>
									关于订房易
								</div>
							</li>
							<li>
								<div :class="titleItemActive==1?'menu-item active':'menu-item'" @click="scrollTo(1)">
									<i class="bn-left-i"></i>
									关于龙腾捷旅
								</div>
							</li>
							<li>
								<div :class="titleItemActive==2?'menu-item active':'menu-item'" @click="scrollTo(2)">
									<i class="bn-left-i"></i>
									我们的目标
								</div>
							</li>
							<li class="bn-left-padding">
								<i class="bn-left-ico"></i>
							</li>
						</ul>

					</div>
				</div>
				
				<div class="bn-right" >
					<ul class="about-br bn-padding">
						<li  class="about-item">
							<h1>关于订房易</h1>
							<p>
								订房易所有产品均为批发的预付价格，价格优势大，房态明确，分即时确认和等待确认两种。即时确认的酒店产品，房态和房价都是即时确认。我们并向长期合作客户提供授信额度，结算灵活。集团采购的酒店覆盖面广，我们的核心产品是港澳酒店及港澳自由行产品，重点产品是国内主要城市及旅游目的地酒店，同时还以直采及接入国际批发商系统方式提供亚洲乃至全球的酒店预订。
							</p>
							<p>● 全球最强的香港酒店预订资源！</p>
							<p>● 40万家港澳及国内酒店可供预订！</p>
							<p>● 超过60万家海外酒店预订资源！</p>
							<p>● 15万家酒店可实时确认！</p>
							<p>● 每天大量中、港、澳及海外包房酒店促销优惠！</p>
							<p>● 提供24小时预订服务支持！</p>
							
							
							<p class="bn-mg-top">客户可以自行在网上注册，也可以通过电话咨询注册，或者通过龙腾捷旅地面销售经理签署订房易协议，通过审核，客户将拥有预订（查询）帐号及密码，客户可以开通和管理N个操作员权限，在订房易上查询和预订。</p>
						</li>

						<li class="about-item">
							<h1>关于龙腾捷旅</h1>
							<p>龙腾捷旅订房集团，是目前中国颇具规模的、专业的酒店预订（B2B&B2C）资源提供商，在中国各大主要城市均设有分公司及办事处，并拥有提供大中华酒店及自由行产品资源的在线预订平台（B2B）“订房易”。是目前国内营销网络布局最广及“预付”产品资源最丰富的同业批发商。</p>
							<p class="bn-mg-top">长期以来，集团致力向中国各地旅游同业推介香港酒店，至2023年底，龙腾捷旅以包销（G.T.D）模式合作的香港酒店超过80间，合作酒店更高达200间。平均每月订房量超过300000间晚，已成为全球最大的香港酒店预订资源提供商（F.I.T）澳门酒店预订资源亦名列前茅。</p>
							<p class="bn-mg-top">2013年开始，集团已将订房资源扩展至全国范围乃至海外市场，向各地同业提供中国各大商务城市及度假目的地的酒店预订和自由行套票业务。公司的目标是致力成为大中华区拥有雄厚资源的酒店及自由行产品预订提供商。2023年度，龙腾捷旅销售了超过400万间酒店客房及自由行产品。目前系统的常用库存产品约有40多万家酒店产品，包括港澳酒店、内地酒店以及台湾等东南亚海外酒店，产品数目及自游行产品资源在持续增长中。</p>
							<p class="bn-mg-top">除地面分公司及PC端、微信端的预订平台外，集团还出版了《全球酒店订房宝典》等宣传媒体，每月并编制了业内权威的“香港酒店订房价格指数”。</p>
							<p class="bn-mg-top">自2013年起，龙腾捷旅已进入IT化、平台化运作阶段，公司推出的“订房易”交易系统（B2B）,集产品、预订、财务、管理功能为一体，是业内成熟的酒店及自游行产品分销平台。</p>
						
						</li>

						<li class="about-item">
							<h1>我们的目标</h1>
							<p>
								公司在加强资源的基础上，加大技术研发投入，2013年建成了行业内领先的 B2B 订房平台——订房易，可以在线预订大中华区乃至海外酒店及自由行产品，提高了整个行业的效率。现阶段我们要做的事情其实很 简单，就是将以酒店预订为核心产品的自游行资源放在一个 I.T 系统内，融入互联生态，以“一对多”的方 式分销

							</p>

							<p class="bn-mg-top">在市场的分工中，我们是一个以开放式系统运作的产品资源提供商，服务于各大 OTA、开放平台及传 统旅行社。现阶段，我们可对标的旅行商为“众信”及“凯撒”等。</p>
							<p class="bn-mg-top">我们的长期战略目标是：成为以酒店预订为核心的自由行产品交易品台（B2B），成为 B 端的去哪儿。 并衍生资源商子品牌（B2B）及直销子品牌（B2C）。</p>
					
						</li>
					</ul>
				</div>
				
			</div>
		</div>

		<div class="home-footer">
			<div class="home-box home-footer-t">
				<div class="top">
					<div class="left home-contact">
						<h3>了解我们</h3>
						<router-link to="about">关于我们</router-link>
						<router-link to="contact">联系我们</router-link>
						<router-link to="contact">投诉建议</router-link>
						<router-link to="join">诚聘英才</router-link>
						
					</div>
					<div class="middle home-contact">
						<h3>客户须知</h3>
						<router-link to="introduction">预订须知</router-link>
						<router-link to="introduction">协议下载</router-link>
						<router-link to="introduction">教程下载</router-link>
					</div>
					<div class="right home-contact">
						<h3>邮箱地址</h3>
						<a href="#">国内酒店合作 chinahotel-1@cnbooking.net</a>
						<a href="#">国际酒店合作 globalhotel-33@cnbooking.net</a>
						<a href="#">OTA合作 channel-3@cnbooking.net</a>
						<a href="#">旅行社合作 chinahotel-3@cnbooking.net</a>
					</div>
					<div class="right-side home-contact">
						<h3>微信二维码</h3>
						<img src="./../../assets/img/ewm.png" alt="" />
					</div>
					<div class="clear"></div>
				</div>
				<div class="bottom">
					<img src="./../../assets/img/home-footer-logo.png" alt="" />
					<div>
						<h4>Copyright©2013-2017,dingfangyi.com.All rights reserved.</h4>
						<h4>
							<a href="#" style="text-decoration: none; color: #999;">粤ICP备17131089号</a>
							<a target="_blank" href="#" style="text-decoration: none; color: #999; float: right;">
								<img src="./../../assets/img/ga.png" />
								    粤公网安备 44030302000423号
							</a>
						</h4>
					</div>
				</div>
			</div>
		</div>
	</div>
	</div>
</template>
<script>
	import FooterS from '../Footer-s.vue'
    import loginHeader from '../loginHeader'//头部

    export default {
        components: { FooterS ,loginHeader},
        data(){
            return{
                isFixed:false,
                titleItemActive:0,
            }
        },
        mounted(){
            window.addEventListener('scroll', this.handleScroll,false)
        },
        destroyed(){
            window.removeEventListener('scroll', this.handleScroll,false)
        },
        methods:{
            handleScroll(){
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                this.isFixed = scrollTop>=330?true:false;
                if(!(document.querySelectorAll('.about-item')[1].offsetTop)){
                    return
                }
                var list=document.querySelectorAll('.about-item');
                if(list[1].offsetTop+300>scrollTop){
                    this.titleItemActive=0;
                }else if(list[2].offsetTop+300>scrollTop){
                    this.titleItemActive=1;
                }else{
                    this.titleItemActive=2;
                }
            },
            scrollTo(ind){
                var list=document.querySelectorAll('.about-item');
                var top=list[ind].offsetTop+310;
                this.titleItemActive=ind;
                document.body.scrollTop = document.documentElement.scrollTop = top;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/info/about.vue